import{m as e}from"./chunk-HBP5N4FR.js";e();var s=(t,n)=>new Date().getTime()-t>n;export{s as a};
//# sourceMappingURL=chunk-3VOPLXJ4.js.map
